import axios, { AxiosResponse } from "axios"

interface ForzarConciliacionRequestBodyProps {
  movimientoBancarioIdsExternos: string[]
}
/**
 * Forces the reconciliation of a bank movement.
 * @param requestBody - The request body containing the necessary information for the reconciliation.
 *                      It should include a list of external IDs (movimientoBancarioIdsExternos).
 * @returns A promise that resolves to the Axios response.
 */
export async function forzarConciliacion(
  requestBody: ForzarConciliacionRequestBodyProps
): Promise<AxiosResponse> {
  const response = await axios.put(
    `/MovimientoBancario/forzar-conciliacion`,
    requestBody
  )
  return response
}

interface RestaurarConciliacionForzadaRequestBodyProps {
  movimientoBancarioIdsExternos: Array<string>
}
/**
 * Restores a forced reconciliation for a bank movement.
 * @param requestBody - The request body containing the necessary information for the restoration.
 *                      It should include a list of external IDs (movimientoBancarioIdsExternos).
 * @returns A Promise that resolves to the AxiosResponse object.
 */
export async function restaurarConciliacionForzada(
  requestBody: RestaurarConciliacionForzadaRequestBodyProps
): Promise<AxiosResponse> {
  const response = await axios.put(
    `/MovimientoBancario/restaurar-conciliacion-forzada`,
    requestBody
  )
  return response
}

interface AddNotaMovimientoBancarioRequestBodyProps {
  idExterno: string
  nota: string | null
}
/**
 * Adds a nota (note) to a movimiento bancario (bank movement).
 * @param requestBody - The request body containing the necessary data to add the nota.
 * @returns A Promise that resolves to the AxiosResponse object.
 */
export async function addNotaMovimientoBancario(
  requestBody: AddNotaMovimientoBancarioRequestBodyProps
): Promise<AxiosResponse> {
  const response = await axios.patch(
    `/MovimientoBancario/${requestBody.idExterno}/nota`,
    requestBody
  )
  return response
}
